// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IKXrunVg8H80lyFVUHst{padding:0 64px;overflow-x:hidden;overflow-y:auto}.vye13wInCcEo7TnojhZk{flex-direction:column;flex:1;width:100%;max-width:760px;margin:0 auto;padding:0 20px;display:flex}.tmEe_T_OAMIoIbl_kfg4{width:100%;display:flex}.QuoJYuZph7gV5I_Ye9Mj{align-items:flex-end;min-height:160px;margin-bottom:24px;display:flex}.QuoJYuZph7gV5I_Ye9Mj img{width:100%;height:auto;display:block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `IKXrunVg8H80lyFVUHst`,
	"content": `vye13wInCcEo7TnojhZk`,
	"pageHeader": `tmEe_T_OAMIoIbl_kfg4`,
	"previewImageContainer": `QuoJYuZph7gV5I_Ye9Mj`
};
export default ___CSS_LOADER_EXPORT___;
